<template>
    <div class="logistics" style="overflow: hidden">
        <div style="height: 1.33rem;">
            <cus-field
                    show-action
                    input-background="#f1f1f1"
                    type="search"
                    v-model="searchKey"
                    placeholder="请输入订单号或运单号"
                    @search="onSearch"
            ></cus-field>
            <div
                    v-show="Object.keys(tracking).length > 0"
                    class="trace"
                    :style="traceStyle"
                    ref="traceWrap"
            >
                <div
                        class="trace-header"
                        ref="traceHeader"
                        @click.prevent="handleCLick"
                        @touchstart.prevent="handleTouchStart"
                        @touchmove.prevent="handleTouchMove"
                        @touchend.prevent="handleTouchEnd"
                >
                    <span v-show="carLocation">当前位置：{{carLocation}}</span>
                    <span v-show="tracking.orderNumber.length>0">订单号：{{tracking.orderNumber.length>0?tracking.orderNumber[0].orderNumber:''}}</span>
                    <span v-show="tracking.trackingNumber">运单号：{{tracking.trackingNumber}}</span>
                </div>
                <div class="trace-container" @scroll.stop ref="traceContent">
                    <template v-for="(item, index) in tracking.recordList">
                        <step :key="index" :value="item" v-if="item.status === 12">
                            <span>
                           车辆已到达
                            <a :href="'tel:' + item.prevStation.phone"
                               class="highlight">
                                [{{ item.prevStation.name }}]
                            </a>
                          </span>
                        </step>
                        <step :key="index" :value="item" v-else-if="item.status === 11">
                            <span>包裹已被取消</span>
                        </step>
                        <step :key="index" :value="item" v-else-if="item.status === 10">
              <span>
                <a
                        :href="'tel:' + item.prevStation.phone"
                        class="highlight"
                >已签收，感谢使用{{item.prevStation.name}}，期待再次为您服务！</a>
              </span>
                        </step>
                        <step :key="index" :value="item" v-else-if="item.status === 9">
              <span>
                包裹已由配送员
                <a :href="'tel:' + item.phone" class="highlight">[{{item.name}}]</a>
                送达目的地（联系电话：
                <a :href="'tel:' + item.phone" class="highlight">[{{item.phone}}]</a>）
                  <p>{{address}}附近</p>
              </span>
                        </step>
                        <step :key="index" :value="item" v-else-if="item.status === 8">
              <span>
                <a
                        :href="'tel:' + item.prevStation.phone"
                        class="highlight"
                >{{item.prevStation.name }}</a>
                配送员
                <a :href="'tel:' + item.phone" class="highlight">{{item.name }}</a>
                正在配送（联系电话：
                <a
                        :href="'tel:' + item.phone"
                        class="highlight"
                >{{ item.phone }}</a>）
              </span>
                        </step>
                        <step :key="index" :value="item" v-else-if="item.status === 7">
              <span>
                包裹到达
                <a
                        :href="'tel:' + item.prevStation.phone"
                        class="highlight"
                >[{{ item.prevStation.name }}]</a>
              </span>
                        </step>
                        <step :key="index" :value="item" v-else-if="item.status === 6">
              <span>
                包裹在
                <a
                        :href="'tel:' + item.prevStation.phone"
                        class="highlight"
                >[{{ item.prevStation.name }}]</a>
                发往
                <a
                        :href="'tel:' + item.nextStation.phone"
                        class="highlight"
                >[{{ item.nextStation.name }}]</a>
              </span>
                        </step>
                        <step :key="index" :value="item" v-else-if="item.status === 5">
              <span>
                包裹正在
                <a
                        :href="'tel:' + item.prevStation.phone"
                        class="highlight"
                >[{{ item.prevStation.name }}]</a>
                扫描装车中！准备发往下一站
              </span>
                        </step>
                        <step :key="index" :value="item" v-else-if="item.status === 4">
              <span>
                包裹已到达
                <a
                        :href="'tel:' + item.prevStation.phone"
                        class="highlight"
                >[{{ item.prevStation.name }}]</a>
              </span>
                        </step>
                        <step :key="index" :value="item" v-else-if="item.status === 3">
              <span>
                包裹已从
                <a
                        :href="'tel:' + item.prevStation.phone"
                        class="highlight"
                >[{{ item.prevStation.name }}]</a>
                发往
                <a
                        :href="'tel:' + item.nextStation.phone"
                        class="highlight"
                >[{{ item.nextStation.name }}]</a>
              </span>
                        </step>
                        <step :key="index" :value="item" v-else-if="item.status === 2">
              <span>
                包裹已由
                <a
                        :href="'tel:' + item.prevStation.phone"
                        class="highlight"
                >[{{ item.prevStation.name }}]</a>
                开单受理
              </span>
                        </step>
                        <step
                                :key="index"
                                :value="item"
                                v-else-if="item.status === 1 && item.statusName === '待开单'"
                        >
              <span>
                配送员
                <a :href="'tel:' + item.phone" class="highlight">[{{ item.name }}]</a>
                完成揽件
              </span>
                        </step>
                        <step
                                :key="index"
                                :value="item"
                                v-else-if="item.status === 1 && item.statusName !== '待开单'"
                        >
              <span>
                配送员
                <a :href="'tel:' + item.phone" class="highlight">[{{ item.name }}]</a>
                正在前往提货
              </span>
                        </step>
                        <step :key="index" :value="item" v-else-if="item.status === 0">
              <span>
                商户
                <a :href="'tel:' + item.phone" class="highlight">[{{
                    item.name
                  }}]</a>
                已下单
              </span>
                        </step>
                    </template>
                </div>
            </div>
        </div>
        <van-notice-bar
                v-show="tracking.delayReason?true:false&&tracking.recordList[0].status<9"
                :text="tracking.delayReason"
                color="red"
                :left-icon="require('../../assets/icon_notice.png')"
        ></van-notice-bar>
        <div id="allmap" :class="{ fullScreen: fullMap }" v-show="mapShow" ref="map"></div>
    </div>
</template>

<script>
    export default {
        name: "Logistics",
        components: {
            Step: () => import("@/components/Step")
        },
        data() {
            return {
                fullMap: false,
                // searchKey: '',
                searchKey: "",
                mapShow: true,
                BMap: null,
                address: "",
                trackingNumber: "",
                tracking: {
                    orderNumber:[]
                },
                carLocation: "",
                maxTranslate: 0,
                currentTranslate: 0,
                preTranslate: 0,
                traceHeight: 0,
                startClientY: 0,
                touchMoveY: 0,
                transitionProp: "all",
                traceBackground: "transparent",
                timeStamp: 0,
                course: "",//航向
            };
        },
        computed: {
            traceStyle() {
                return {
                    transform: "translateY(" + (this.currentTranslate - 60) + "px)",
                    height: this.traceHeight + "px",
                    transition: "all 200ms ease-in-out 0s",
                    transitionProperty: this.transitionProp,
                    background: this.traceBackground,
                    padding: this.currentTranslate === 0 ? "0.27rem 0.27rem 0" : "0 0.27rem"
                };
            }
        },
        methods: {
            //隐藏字符
            hiddenCharacter(str, frontLen, endLen) {
                var len = str.length - frontLen - endLen;
                var xing = '';
                for (var i = 0; i < len; i++) {
                    xing += '*';
                }
                return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
            },
            handleMapClick() {
                this.currentTranslate = this.preTranslate = this.maxTranslate;
            },
            handleTouchStart(e) {
                // this.timeStamp = e.timeStamp
                this.transitionProp = "none";
                this.startClientY = e.targetTouches[0].clientY;
            },
            handleTouchMove(e) {
                let {clientY} = e.targetTouches[0];
                let translate = clientY - this.startClientY;
                let currentTranslate = this.preTranslate + translate;
                if (currentTranslate > 0 && this.$refs.traceContent.scrollTop > 0) {
                    return;
                }
                if (currentTranslate < 0) {
                    currentTranslate = 0;
                }
                if (currentTranslate > this.maxTranslate) {
                    currentTranslate = this.maxTranslate;
                }
                this.currentTranslate = currentTranslate;
                this.touchMoveY = translate;
            },
            handleTouchEnd() {
                // if (e.timeStamp - this.timeStamp <= 300 && e.path[0].classList.contains('highlight')) {
                //     window.location.href = e.path[0].dataset.tel
                // }
                this.transitionProp = "all";
                if (this.$refs.traceContent.scrollTop > 0) return;
                if (this.touchMoveY < -50) {
                    this.currentTranslate = 0;
                    this.traceBackground = "#f5f5f5";
                } else {
                    this.currentTranslate = this.maxTranslate;
                    this.traceBackground = "transparent";
                }
                this.preTranslate = this.currentTranslate;
            },

            // 点击上滑
            handleCLick() {
                this.transitionProp = "all";
                if (this.currentTranslate === 0) {
                    this.currentTranslate = this.maxTranslate;
                    this.traceBackground = "transparent";
                } else {
                    this.currentTranslate = 0;
                    this.traceBackground = "#f5f5f5";
                }
                this.preTranslate = this.currentTranslate;
            },
            async onSearch(trackingNumber) {
                if (!trackingNumber) {
                    this.$toast({
                        message: "请输入订单号!",
                        duration: 1000
                    });
                    return;
                }
                this.$toast.loading({
                    message: "加载中...",
                    mask: true,
                    duration: 0
                });
                let params = {
                    params: {
                        trackingNumber: trackingNumber
                    }
                };
                this.carLocation = ''
                let trackingRes = await this.$axios
                    .post("tracking/sign/Logistics/information/tracking", params)
                    .catch(err => {
                        this.$toast.clear();
                        this.$toast({
                            message: err.data.msg,
                            duration: 1000
                        });
                    });
                if (!trackingRes.data.data) return
                this.trackingNumber = trackingNumber;
                let tracking = (this.tracking = trackingRes.data.data);
                if (this.tracking.recordList[this.tracking.recordList.length - 1]) {
                    if (!isNaN(Number(this.tracking.recordList[this.tracking.recordList.length - 1].name))) {
                        let len = (this.tracking.recordList[this.tracking.recordList.length - 1].name.length - 3) / 2
                        this.tracking.recordList[this.tracking.recordList.length - 1].name = this.hiddenCharacter(this.tracking.recordList[this.tracking.recordList.length - 1].name, len, len)
                    } else {
                        if (this.tracking.recordList[this.tracking.recordList.length - 1].name.length === 2) {
                            this.tracking.recordList[this.tracking.recordList.length - 1].name = this.hiddenCharacter(this.tracking.recordList[this.tracking.recordList.length - 1].name, 1, 0)
                        } else {
                            let len = (this.tracking.recordList[this.tracking.recordList.length - 1].name.length - 1) / 2
                            this.tracking.recordList[this.tracking.recordList.length - 1].name = this.hiddenCharacter(this.tracking.recordList[this.tracking.recordList.length - 1].name, len, len)
                        }
                    }
                }
                let {
                    beginLat,
                    beginLng,
                    endLat,
                    endLng,
                    beginOrganName,
                    endOrganName,
                } = tracking;
                let endStatus = tracking.recordList[0].status;
                let endNode = tracking.recordList[0];
                if (!beginLat || !endLat) {
                    this.maxTranslate = this.currentTranslate = this.preTranslate = 0;
                    this.traceHeight = this.$refs.map.clientHeight;
                    this.$toast.clear();
                    return;
                }
                let beginPoint = new BMap.Point(beginLng, beginLat);
                let endPoint = new BMap.Point(endLng, endLat);
                let addressPoint = new BMap.Point(tracking.recordList[0].lng, tracking.recordList[0].lat);
                var gc = new BMap.Geocoder();  //初始化，Geocoder类
                gc.getLocation(addressPoint, (rs) => {   //getLocation函数用来解析地址信息，分别返回省市区街等
                    this.address = rs.address
                });
                if (!this.BMap) this.BMap = new BMap.Map("allmap");
                this.BMap.addEventListener("touchstart", () => {
                    this.currentTranslate = this.preTranslate = this.maxTranslate;
                });
                this.BMap.clearOverlays();
                this.BMap.centerAndZoom(new BMap.Point(beginLng, beginLat), 7);
                this.BMap.setViewport([beginPoint, endPoint], {
                    margins: [30, 30, 30, 30]
                });
                this.BMap.enableScrollWheelZoom(true);
                if (endStatus === 6) {
                    this.BMap.clearOverlays()
                    this.drawPoint(beginLat, beginLng, beginOrganName, 'begin')
                    this.drawPoint(endLat, endLng, endOrganName, 'end')
                    this.BMap.setViewport([beginPoint, endPoint], {
                        margins: [30, 30, 30, 30]
                    })
                    if (!this.tracking.recordList[0].nextStation.id || tracking.vehicleStatus === 3) {
                        await this.drawPath(beginPoint, endPoint, 'begin')
                    } else {
                        let params = {
                            params: {
                                plateNumber: this.tracking.recordList[0].plateNumber,
                                organId: this.tracking.recordList[0].nextStation.id,
                            }
                        }
                        let trackingRes = await this.$axios.get('gps/getGPSTrackingByPlateNumber', params).catch(err => {
                            this.$toast({
                                message: err.data.msg,
                                duration: 1000
                            })
                        })
                        let data = trackingRes.data.data
                        if (data.length === 0 || data == '') {
                            await this.drawPath(beginPoint, endPoint, 'begin')
                            this.$toast.clear()
                        } else if (data[0].acc == '-1') {
                            await this.drawPath(beginPoint, endPoint, 'begin')
                        } else {
                            let {
                                lat,
                                lng,
                                speed
                            } = data[0]
                            this.course = data[0].course
                            let carPoint = new BMap.Point(lng, lat)
                            await this.drawPath(beginPoint, carPoint, 'begin')
                            await this.drawPath(carPoint, endPoint, 'end')
                            //设备离线
                            if (data[0].device_info !== 0) {
                                this.$toast.clear()
                                return
                            }
                            let text = `当前时速：${speed}Km/H`
                            this.drawPoint(lat, lng, text, 'car')
                            let geoc = new BMap.Geocoder()
                            geoc.getLocation(carPoint, res => {
                                this.carLocation = res.address
                                this.$nextTick(function () {
                                    this.maxTranslate = this.$refs.map.clientHeight - this.$refs.traceHeader.offsetHeight
                                    this.currentTranslate = this.preTranslate = this.maxTranslate - 100
                                    this.traceHeight = this.$refs.map.clientHeight
                                })
                            })
                        }
                    }
                } else if (endStatus <= 5) {
                    this.BMap.clearOverlays();
                    this.drawPoint(beginLat, beginLng, beginOrganName);
                    this.BMap.setViewport([beginPoint], {
                        margins: [30, 30, 30, 30]
                    });
                } else if (endStatus >= 7) {
                    this.BMap.clearOverlays();
                    this.drawPoint(endLat, endLng, endOrganName);
                    // this.BMap.setViewport([endPoint], {
                    //     margins: [30, 30, 30, 30]
                    // });
                }
                this.$toast.clear();
                this.$nextTick(function () {
                    this.maxTranslate =
                        this.$refs.map.clientHeight - this.$refs.traceHeader.offsetHeight;
                    this.currentTranslate = this.preTranslate = this.maxTranslate - 100;
                    this.traceHeight = this.$refs.map.clientHeight;
                });
                this.tracking.recordList.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
            },

            /**
             * 画路线
             * @param begin 起始点
             * @param end 终止点
             * @param colorType
             * @returns {Promise<any>}
             */
            drawPath(begin, end, colorType) {
                this.begin = begin;
                this.end = end;
                return new Promise(resolve => {
                    let color = {
                        begin: "#FE9329",
                        end: "#042D6F"
                    };
                    let driving = new BMap.DrivingRoute(this.BMap);
                    driving.search(begin, end);
                    driving.setSearchCompleteCallback(res => {
                        let path = res
                            .getPlan(0)
                            .getRoute(0)
                            .getPath();
                        let polyline = new BMap.Polyline(path, {
                            strokeColor: color[colorType],
                            strokeWeight: 3,
                            strokeStyle: "solid"
                        });
                        this.BMap.addOverlay(polyline);
                        resolve();
                    });
                });
            },

            /**
             * 画点
             * @param lat
             * @param lng
             * @param text
             * @param type car|begin|end
             */
            drawPoint(lat, lng, text, type) {
                let that = this;
                let point = new BMap.Point(lng, lat);

                function customOverlay(_point, _text) {
                    this._point = point;
                    this._text = _text;
                }

                customOverlay.prototype = new BMap.Overlay();
                customOverlay.prototype.initialize = function (map) {
                    this._map = map;
                    let div = (this._div = document.createElement("div"));
                    div.style.position = "absolute";
                    if (type !== "car") {
                        let iconSpan = (this._iconSpan = document.createElement("span"));
                        iconSpan.style.position = "absolute";
                        iconSpan.style.display = "inline-block";
                        iconSpan.style.width = "0.65rem";
                        iconSpan.style.height = "0.73rem";
                        let textSpan = document.createElement("span");
                        textSpan.style.position = "absolute";
                        textSpan.style.left = "0";
                        textSpan.style.top = "0.11rem";
                        textSpan.style.lineHeight = "0.62rem";
                        textSpan.style.borderRadius = "0.31rem";
                        textSpan.style.color = "#fff";
                        textSpan.style.padding = "0 0.25rem 0 0.68rem";
                        textSpan.style.whiteSpace = "nowrap";
                        let iconPath =
                            type === "begin"
                                ? require("../../assets/map_point_start.png")
                                : require("../../assets/map_point_end.png");
                        iconSpan.style.background =
                            "url(" + iconPath + ") center / 100% no-repeat";
                        textSpan.style.backgroundColor =
                            type === "begin" ? "#FE9329" : "#042D6F";
                        textSpan.innerText = this._text;
                        div.appendChild(textSpan);
                        div.appendChild(iconSpan);
                    } else {
                        let x = 0, y = 0;
                        if (20 < that.course && that.course <= 65) {
                            x = -512;
                            y = -139;
                        } else if (65 < that.course && that.course <= 110) {
                            x = -362;
                            y = -112;
                        } else if (110 < that.course && that.course <= 155) {
                            x = -512;
                            y = -110;
                        } else if (155 < that.course && that.course <= 200) {
                            x = -462;
                            y = -113;
                        } else if (200 < that.course && that.course <= 245) {
                            x = -417;
                            y = -111;
                        } else if (245 < that.course && that.course <= 290) {
                            x = -362;
                            y = -140;
                        } else if (290 < that.course && that.course <= 335) {
                            x = -412;
                            y = -140;
                        } else {
                            x = -462;
                            y = -138;
                        }
                        let iconSpan = (this._iconSpan = document.createElement("span"));
                        iconSpan.style.width = "0.75rem";
                        iconSpan.style.height = "0.76rem";
                        iconSpan.style.position = "absolute";
                        let iconPath = require("../../assets/Car@2x.png"); //汽车
                        iconSpan.style.background = "url(" + iconPath + ") ";
                        iconSpan.style.backgroundSize = "180px";
                        iconSpan.style.backgroundPosition = `${x}px ${y}px`;
                        let textSpan = document.createElement("span");
                        textSpan.style.position = "absolute";
                        textSpan.style.left = "1rem";
                        textSpan.style.top = "50%";
                        textSpan.style.transform = `translateY(-50%)`;
                        textSpan.style.padding = "0.11rem";
                        textSpan.style.fontSize = "0.27rem";
                        textSpan.style.backgroundColor = "#FE9329";
                        textSpan.style.color = "#fff";
                        textSpan.style.whiteSpace = "nowrap";
                        textSpan.innerText = text;
                        iconSpan.appendChild(textSpan);
                        div.appendChild(iconSpan);
                    }
                    that.BMap.getPanes().labelPane.appendChild(div);
                    return div;
                };
                customOverlay.prototype.draw = function () {
                    let map = this._map;
                    let pixel = map.pointToOverlayPixel(this._point);
                    if (type === "car") {
                        this._div.style.left =
                            pixel.x - this._iconSpan.offsetWidth / 2 + "px";
                        this._div.style.top =
                            pixel.y - this._iconSpan.offsetHeight / 2 + "px";
                    } else {
                        this._div.style.left =
                            pixel.x - this._iconSpan.offsetWidth / 2 + "px";
                        this._div.style.top = pixel.y + "px";
                    }
                };
                let myOverlay = new customOverlay(point, text);
                that.BMap.addOverlay(myOverlay);
            }
        },
        mounted() {
           this.$nextTick(()=>{
               this.maxTranslate = this.currentTranslate = this.preTranslate =
                   this.$refs.map.clientHeight - this.$refs.traceHeader.offsetHeight;
               this.traceHeight = this.$refs.map.clientHeight;
           })
            if (this.$route.params.id) {
                this.onSearch(this.$route.params.id);
            }
            if (this.$route.query.id) {
                this.onSearch(this.$route.query.id);
            }
        }
    };
</script>

<style scoped lang="scss">
    .logistics {
        overflow: hidden;
        flex: 1;
        display: flex;
        flex-direction: column;
        position: relative;

        #allmap {
            width: 100%;
            flex: 1;
        }
    }

    .trace {
        position: relative;
        z-index: 8;
        padding: 0 0.27rem;
        background-color: transparent;
        display: flex;
        flex-direction: column;
        /*position: absolute;*/
        /*bottom: 0;*/
        /*left: 0;*/
        /*right: 0;*/

        .trace-header {
            font-size: 0.35rem;
            color: #2e2e2e;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            padding: 0.55rem 0 0.12rem 0;
            box-sizing: border-box;
            position: relative;

            &::after {
                content: "";
                position: absolute;
                width: 0.56rem;
                height: 0.13rem;
                top: 0.13rem;
                left: 50%;
               background: url("../../assets/icon_arrow.png") center / 100% no-repeat;
                transform: translateX(-50%);
            }

            span {
                padding: 0.12rem 0.92rem;
            }
        }

        &-container {
            flex: 1;
            margin-top: 0.21rem;
            padding-top: 0.21rem;
            background-color: #fff;
            overflow: scroll;
        }
    }

    .highlight {
        color: #042d6f;
    }

    .trace-container {
        padding-bottom: 2rem;
        overflow: auto;
    }
</style>
